import * as React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  action: {
    alignItems: 'flex-start',
  },
}));

export interface VseAlertComponentProps extends Pick<React.HTMLAttributes<HTMLElement>, 'className'> {
  theme: Theme,
  severity: 'error' | 'info' | 'success' | 'warning', // copied from material-ui Alert API
  title?: string,
  messages: string[],
  onDismiss: (messagesToDismiss: string[]) => void,
}

export function VseAlertComponent(props: VseAlertComponentProps) {
  const classes = useStyles(props.theme);

  return (
    props.messages.length === 0 ? null : (
      <Alert
        className={props.className}
        classes={{
          root: classes.root,
          action: classes.action,
        }}
        severity={props.severity}
        onClose={
          () => props.onDismiss ? props.onDismiss(props.messages) : null
        }
      >
        {props.title ? (
          <AlertTitle>{props.title}</AlertTitle>
        ) : undefined}
        {props.messages.length === 1 ? <div dangerouslySetInnerHTML={{__html: props.messages[0]}} /> : (
          <ul>
            {props.messages.map((s, i) => <li key={i} dangerouslySetInnerHTML={{ __html: s }} />)}
          </ul>
        )}
      </Alert>
    )
  );
}
